export default "__VITE_ASSET__DAjIqWs5__"